export default {
  dms: {
    dmsKey: {
      id: 'Id',
      chooseDate: 'Tarih giriniz!',
      textArea: 'Döküman içeriği giriniz!',
      name: 'İsim',
      description: 'Tanım',
      title: 'Başlık',
      active: 'Aktif',
      archive: 'Arşiv',
      actions: 'Aksiyonlar',
      edit: 'Düzenle',
      fromDate: 'From Date',
      thruDate: 'Thru Date',
      documentKeyDialogTitle: 'Parametre Tanımı',
      save: 'Kaydet',
      delete: 'Sil',
      DocumentKeyTypeName: 'Döküman Tip Adı',
      Mandatory: 'Zorunlu',
      documentKeyTypeDialogTitle: 'Döküman Tip Tanımı',
      documentKeyIndexDialogTitle: 'Döküman İndeks Anahtar Tanımı',
      documentKeyIndex: 'Döküman İndeks Tipi',
      customerIdMustBeMandatory: 'Müşteri no zorunlu olmalı!',
      someIndiciesMustBeMandatory: 'En az bir index zorunlu olmalı!',
      documentTypeDialogTitle: 'Döküman Tip Tanımı',
      deleteQuestion: 'Silmek istediğinize emin misiniz?',
      valCategoryType: 'Döküman anahtar tanımı girmek zorunludur.',
      valCategoryNameRequired: 'Döküman anahtar adı girmek zorunludur.',
      valCategoryName: '2 ile 250 arasında karakter giriniz.',
      valCategoryDescription: '2 ile 250 arasında karakter giriniz.',
      documentTypeName: 'Döküman Tipi',
      documentTemplateList: 'Şablon',
      fillablecontentList: 'Şablon İçeriği Türü',
      documentTemplateLink: 'Döküman Şablonu Oluştur'
    },
    error: {
      fileshouldbeimage: 'Yüklenen dosyaların hepsi resim dosyası olmalıdır !'
    },
    documentType: {
      name: 'İsim',
      description: 'Tanım',
      fromDate: 'Başlangıç Tarihi',
      thruDate: 'Bitiş Tarihi',
      documentTypeDialogTitle: 'Döküman Tipi Adı Tanımı',
      deleteQuestion: 'Silmek istediğinize emin misiniz?',
      valCategoryType: 'Döküman anahtar adı girmek zorunludur.',
      valCategoryNameRequired: 'Döküman anahtar adı girmek zorunludur.',
      valCategoryName: '2 ile 250 arasında karakter giriniz.',
      valCategoryDescription: '2 ile 250 arasında karakter giriniz.'
    }
  }
};